import {
    Injectable
} from '@angular/core';

import {
    NgbModal
} from '@ng-bootstrap/ng-bootstrap';

import { AnimalAuditReportComponent } from './animal-audit-report.component';

/*
* Service to view the animal audit-report modal.
*/
@Injectable()
export class ViewAnimalAuditReportComponentService {

    constructor(
        private modalService: NgbModal
    ) {
        //
    }

    openComponent(materialKey: number) {
        const modalRef = this.modalService.open(AnimalAuditReportComponent, { size: 'lg' });
        modalRef.componentInstance.materialKey = materialKey;
    }
}
